export class PickupLocationRequest {
}
export class UpdateShippingData {
}
export var AddressType;
(function (AddressType) {
    AddressType["Private"] = "Private";
    AddressType["Business"] = "Business";
})(AddressType || (AddressType = {}));
